import {
  getRequestedShippingMethod,
  getDeliverByDate,
  getShipByDate,
  orderCartTypeSelector,
} from '../../../../data/orders.js'
import {formatOrderDate} from '../../Fields/ByDate.js'
import {useSelector} from '../../../../store.js'
import {FormattedRealDate} from '../../../../common/components/FormattedDate.js'

export default function AwaitingFulfillmentStatus({order}) {
  const cartType = useSelector((state) =>
    orderCartTypeSelector(state, {orderNumber: order.order_number}),
  )

  const requestedShippingMethod = getRequestedShippingMethod(order)
  const deliverByDate = getDeliverByDate(order)
  const shipByDate = getShipByDate(order)

  if (!requestedShippingMethod && !deliverByDate) {
    return null
  }

  return (
    <div>
      {requestedShippingMethod && (
        <div className="fs-n1 text--md-grey">
          <strong>Requested Ship:</strong>
          <div>{requestedShippingMethod}</div>
        </div>
      )}
      {(deliverByDate || shipByDate) && (
        <div className="alert alert--standard alert--x-sm text--md-grey alert--ship-by-date">
          {shipByDate && (
            <div className="fs-n1 lh-1-25">
              <strong>Ship By: </strong>
              <span>
                <FormattedRealDate {...formatOrderDate(shipByDate, cartType)} />
              </span>
            </div>
          )}
          {deliverByDate && (
            <div className="fs-n1 lh-1-25">
              <strong>Deliver By: </strong>
              <span>
                <FormattedRealDate
                  {...formatOrderDate(deliverByDate, cartType)}
                />
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
